var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlock = function SvgBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d50000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.63 35.562 35.651 9.54l2.829 2.829L12.459 38.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 4C13 4 4 13 4 24s9 20 20 20 20-9 20-20S35 4 24 4m0 36c-8.8 0-16-7.2-16-16S15.2 8 24 8s16 7.2 16 16-7.2 16-16 16"
  }))));
};
export default SvgBlock;